module.exports = __webpack_public_path__ + "static/img/Animals.c93c324.png";